import React, {useEffect, useState} from 'react';
import Layout from "../Layout";
import {RoleManagement} from "../components/userManagement/role/role";
import {NotificationManagement} from "../components/notification/notification";
import {ProvinceManagement} from "../components/base_information/province/province";
import {CityManagement} from "../components/base_information/city/city";
import {DegreeManagement} from "../components/base_information/degree/degree";
import {StageDegreeManagement} from "../components/base_information/stage_degree/stage_degree";
import {FieldManagement} from "../components/base_information/field/field";
import {BranchManagement} from "../components/base_information/branch/branch";
import {AgentProfileWorkspace} from "../components/agent/agent_profile/AgentProfileWorkspace";
import {AgentsManagement} from "../components/agent/agents/agents";
import {ChangePassword} from "../components/profile/change_password";
import {Profile} from "../components/profile/profile";
import {Wallet} from "../components/wallet/wallet";
import {BranchCommissionManagement} from "../components/branch_commission/branch_commission";
import {AgentBranchFeeManagement} from "../components/agent_branch_fee/agent_branch_fee";
import {ScheduleManagement} from "../components/schedule/schedule";
import {BankAccountManagement} from "../components/bank_account/bank_account";
import {ConfirmationCommentManagement} from "../components/confirmation_comment/confirmation_comment";
import {BranchDiscountManagement} from "../components/branch_discount/branch_discount";
import {AgentBranchDiscountManagement} from "../components/agent_branch_discount/agent_branch_discount";
import {ReservationManagement} from "../components/reservation/reservation";
import {AgentReservationManagement} from "../components/reservation/agent_reservation_management";
import {UserReservationManagement} from "../components/reservation/user_reservation_management";
import {PersonServiceManagement} from "../components/service/person_service";
import {AgentServiceManagement} from "../components/service/agent_service";
import {AgentBranchDocumentManagement} from "../components/agent_branch_document/agent_branch_document";
import {BranchDocumentManagement} from "../components/branch_document/branch_document";
import {SchedulesManagement} from "../components/schedule/schedule_management";
import {toast} from "react-toastify";
import {UserReportManagement} from "../components/report_user/user/user";
import {UserRoleReportManagement} from "../components/report_user/user_role/user_role";
import Dashboard from "../components/dashboard/dashboard";
import {UserNotificationReportManagement} from "../components/report_user/user_notification/user_notification";
import {WorkReportManagement} from "../components/report_work/work/work";
import {ConsultationReportManagement} from "../components/report_work/consultation/consultation";
import {ServiceReportManagement} from "../components/report_work/service/service";
import {AdminWithdrawalManagement} from "../components/withdrawal/admin_withdrawal";
import {UserWithdrawalManagement} from "../components/withdrawal/user_withdrawal";
import {PaymentReportManagement} from "../components/report_finance/payment/payment";
import {ManualPaymentManagement} from "../components/report_finance/payment/ManualPaymentManagement";
import {AgentBranchCommissionManagement} from "../components/agent_branch_commission/agent_branch_commission";
import {ConsultationPaymentManagement} from "../components/consultation_payment/consultation_payment";
import {AgentReportManagement} from "../components/report_user/agent/agent";
import {AgentIncomeReportManagement} from "../components/report_finance/agent_income/agent_income";
import {SiteIncomeReportManagement} from "../components/report_finance/site_income/site_income";
import {BackOfficePersonManagement} from "../components/back_office/person/person";
import {BackOfficeAgentRequestManagement} from "../components/back_office/agent_request/agent_request";
import {BackOfficeAgentBranchFeeManagement} from "../components/back_office/agent_branch_fee/agent_branch_fee";
import {VoipCall} from "../components/admin_service/voip_call";
import {SendPaymentLink} from "../components/admin_service/send_payment_link";
import {ChangeWalletBalance} from "../components/admin_service/change_wallet_balance";
import {SendNotification} from "../components/admin_service/send_notification_message";
import {DailyWorkReportManagement} from "../components/report_work/daily_work/daily_work";
import {ReferralConfigManagement} from "../components/referral/referral_config/referral_config";
import {ProfileReferral} from "../components/profile/referral_profile";
import {DiscountManagement} from "../components/discount/admin/discount";
import {BranchServiceStepManagement} from "../components/branch_service_step/branch_service_step";
import {AgentBranchSideCostManagement} from "../components/agent_branch_side_cost/agent_branch_side_cost";
import {ServiceFollowUpManagement} from "../components/service_follow_up/service_follow_up";
import {ServicePaymentManagement} from "../components/service_payment/service_payment";
import {UnpaidWorkManagement} from "../components/unpaid_work/unpaid_work";
import {ReferralManagement} from "../components/referral/referral/referral";
import {ReferralPaymentReportManagement} from "../components/report_work/referral_payment/referral_payment";
import {DiscountSiteCostReportManagement} from "../components/report_work/discount_site_cost/discount_site_cost";
import {DiscountUsageReportManagement} from "../components/report_work/discount_usage/discount_usage";
import {ServiceSideCostPaymentManagement} from "../components/service_side_cost_payment/service_side_cost_payment";
import {BackOfficeScheduleManagement} from "../components/back_office/schedule/schedule";
import {BackOfficeReservationManagement} from "../components/back_office/reservation/reservation";
import {BackOfficeWallet} from "../components/back_office/wallet/wallet";
import {BackOfficePersonServiceManagement} from "../components/back_office/service/person_service";
import {BackOfficeAgentServiceManagement} from "../components/back_office/service/agent_service";

const ArticleManagement = React.lazy(
  () => import("../components/article/ArticleManagement").then(
    (module) => ({default: module.ArticleManagement}),
  ),
);

const SEOManagement = React.lazy(
  () => import("../components/seo/SEOManagement").then(
    (module) => ({default: module.SEOManagement}),
  ),
);

const AgentProfileReviewManagement = React.lazy(
  () => import("../components/agent/agent_profile_admin/AgentProfileReviewManagement").then(
    (module) => ({default: module.AgentProfileReviewManagement}),
  ),
);

const HIDDEN_RESOURCE_TITLES = new Set([
  "service_follow_up",
  "person_service_follow_up",
  "agent_service_follow_up",
]);

const Home = () => {
  const [selectedItem, setSelectedItem] = useState("dashboard")
  const [userInfo, setUserInfo] = useState({});
  const [dataRefresh, setDataRefresh] = useState(Date.now())

  const handleItemClick = (item) => {
    if (HIDDEN_RESOURCE_TITLES.has(item)) {
      localStorage.setItem("lastClicked", "dashboard")
      setSelectedItem("dashboard");
      return;
    }

    if (item?.length > 0) {
      if (localStorage.getItem("defaultItem")) {
        window.location.href = "/loading";
        localStorage.setItem("lastClicked", item)
        setSelectedItem(item);
      } else {
        localStorage.setItem("lastClicked", item)
        setSelectedItem(item);
      }
    } else {
      localStorage.setItem("lastClicked", "dashboard")
      setSelectedItem("dashboard");
    }
  };

  useEffect(() => {
    let data = localStorage.getItem('userInfo');
    setUserInfo(data ? JSON.parse(data) : {});

    const item = localStorage.getItem('lastClicked');
    handleItemClick(item);
  }, []);

  useEffect(() => {
    let redirectData = localStorage.getItem('redirect_component');
    let status = localStorage.getItem('status');
    if (redirectData) {
      if (redirectData === "wallet") {
        handleItemClick("wallet");
        if (status === "success") {
          toast.success("تراکنش موفق")
        } else {
          toast.error("تراکنش ناموفق")
        }
        localStorage.removeItem('redirect_component');
        localStorage.removeItem('status');
        setDataRefresh(Date.now())
      }
      if (redirectData === "service") {
        handleItemClick('person_service')
        if (status === "success") {
          toast.success("تراکنش موفق")
        } else {
          toast.error("تراکنش ناموفق")
        }
        localStorage.removeItem('redirect_component');
        localStorage.removeItem('status');
        setDataRefresh(Date.now())
      }
      if (redirectData === "reservation") {
        handleItemClick('reservation')
        if (status === "success") {
          toast.success("تراکنش موفق")
        } else {
          toast.error("تراکنش ناموفق")
        }
        localStorage.removeItem('redirect_component');
        localStorage.removeItem('status');
        setDataRefresh(Date.now())
      }
    }
  }, [dataRefresh]);

  const renderContent = () => {
    switch (selectedItem) {
      case 'roles':
        return (
          <div>
            <RoleManagement/>
          </div>
        );
      case 'notifications':
        return (
          <div>
            <NotificationManagement/>
          </div>
        );
      case 'province':
        return (
          <div>
            <ProvinceManagement/>
          </div>
        );
      case 'city':
        return (
          <div>
            <CityManagement/>
          </div>
        );
      case 'degree':
        return (
          <div>
            <DegreeManagement/>
          </div>
        );
      case 'stage_degree':
        return (
          <div>
            <StageDegreeManagement/>
          </div>
        );
      case 'field':
        return (
          <div>
            <FieldManagement/>
          </div>
        );
      case 'branch':
        return (
          <div>
            <BranchManagement/>
          </div>
        );
      case 'branch_service_step':
        return (
          <div>
            <BranchServiceStepManagement/>
          </div>
        );
      case 'agent_request':
        return (
          <div>
            <AgentProfileWorkspace changeComponent={setSelectedItem}/>
          </div>
        );
      case 'agent_profile_management':
        return (
          <React.Suspense fallback={<div className="p-8 text-center">در حال بارگذاری بررسی پروفایل‌ها...</div>}>
            <AgentProfileReviewManagement/>
          </React.Suspense>
        );
      case 'agents':
        return (
          <div>
            <AgentsManagement/>
          </div>
        );
      case 'change_password':
        return (
          <div>
            <ChangePassword/>
          </div>
        );
      case 'profile':
        return (
          <div>
            <Profile/>
          </div>
        );
      case 'branch_commission':
        return (
          <div>
            <BranchCommissionManagement/>
          </div>
        );
      case 'agent_branch_commission':
        return (
          <div>
            <AgentBranchCommissionManagement/>
          </div>
        );
      case 'branch_discount':
        return (
          <div>
            <BranchDiscountManagement/>
          </div>
        );
      case 'discount':
        return (
          <div>
            <DiscountManagement/>
          </div>
        );
      case 'agent_branch_discount':
        return (
          <div>
            <AgentBranchDiscountManagement/>
          </div>
        );
      case 'agent_branch_fee':
        return (
          <div>
            <AgentBranchFeeManagement/>
          </div>
        );
      case 'schedule':
        return (
          <div>
            <ScheduleManagement/>
          </div>
        );
      case 'reservation':
        return (
          <div>
            <ReservationManagement/>
          </div>
        );
      case 'wallet':
        return (
          <div>
            <Wallet/>
          </div>
        );
      case 'bank_account':
        return (
          <div>
            <BankAccountManagement/>
          </div>
        );
      case 'confirmation_comment':
        return (
          <div>
            <ConfirmationCommentManagement/>
          </div>
        );
      case 'agent_reservation':
        return (
          <div>
            <AgentReservationManagement/>
          </div>
        );
      case 'user_reservation':
        return (
          <div>
            <UserReservationManagement/>
          </div>
        );
      case 'person_service':
        return (
          <div>
            <PersonServiceManagement/>
          </div>
        );
      case 'agent_service':
        return (
          <div>
            <AgentServiceManagement/>
          </div>
        );
      case 'service_payment':
        return (
          <div>
            <ServicePaymentManagement/>
          </div>
        );
      case 'side_cost_payment':
        return (
          <div>
            <ServiceSideCostPaymentManagement/>
          </div>
        );
      case 'service_follow_up':
        return (
          <div>
            <ServiceFollowUpManagement/>
          </div>
        );
      case 'person_service_follow_up':
        return (
          <div>
            <ServiceFollowUpManagement/>
          </div>
        );
      case 'agent_service_follow_up':
        return (
          <div>
            <ServiceFollowUpManagement/>
          </div>
        );
      case 'unpaid_work':
        return (
          <div>
            <UnpaidWorkManagement/>
          </div>
        );
      case 'agent_branch_document':
        return (
          <div>
            <AgentBranchDocumentManagement/>
          </div>
        );
      case 'agent_branch_side_cost':
        return (
          <div>
            <AgentBranchSideCostManagement/>
          </div>
        );
      case 'branch_document':
        return (
          <div>
            <BranchDocumentManagement/>
          </div>
        );
      case 'schedule_management':
        return (
          <div>
            <SchedulesManagement/>
          </div>
        );
      case 'user_report':
        return (
          <div>
            <UserReportManagement/>
          </div>
        );
      case 'user_role_report':
        return (
          <div>
            <UserRoleReportManagement/>
          </div>
        );
      case 'user_notification_report':
        return (
          <div>
            <UserNotificationReportManagement/>
          </div>
        );
      case 'agent_report':
        return (
          <div>
            <AgentReportManagement/>
          </div>
        );
      case 'referral_payment_report':
        return (
          <div>
            <ReferralPaymentReportManagement/>
          </div>
        );
      case 'discount_usage_report':
        return (
          <div>
            <DiscountUsageReportManagement/>
          </div>
        );
      case 'discount_site_cost_report':
        return (
          <div>
            <DiscountSiteCostReportManagement/>
          </div>
        );
      case 'work_report':
        return (
          <div>
            <WorkReportManagement/>
          </div>
        );
      case 'daily_work_report':
        return (
          <div>
            <DailyWorkReportManagement/>
          </div>
        );
      case 'consultation_report':
        return (
          <div>
            <ConsultationReportManagement/>
          </div>
        );
      case 'service_report':
        return (
          <div>
            <ServiceReportManagement/>
          </div>
        );
      case 'person_withdrawal':
        return (
          <div>
            <UserWithdrawalManagement/>
          </div>
        );
      case 'report_withdrawal':
        return (
          <div>
            <AdminWithdrawalManagement/>
          </div>
        );
      case 'manual_payments':
        return (
          <div className="p-4">
            <ManualPaymentManagement/>
          </div>
        );
      case 'report_payment':
        return (
          <div>
            <PaymentReportManagement/>
          </div>
        );
      case 'agent_income':
        return (
          <div>
            <AgentIncomeReportManagement/>
          </div>
        );
      case 'site_income':
        return (
          <div>
            <SiteIncomeReportManagement/>
          </div>
        );
      case 'consultation_payment':
        return (
          <div>
            <ConsultationPaymentManagement/>
          </div>
        );
      case 'dashboard':
        return (
          <div>
            <Dashboard/>
          </div>
        );
      case 'modify_person':
        return (
          <div>
            <BackOfficePersonManagement/>
          </div>
        );
      case 'add_agent':
        return (
          <div>
            <BackOfficeAgentRequestManagement/>
          </div>
        );
      case 'modify_agent_branch_fee':
        return (
          <div>
            <BackOfficeAgentBranchFeeManagement/>
          </div>
        );
      case 'back_office_schedule':
        return (
          <div>
            <BackOfficeScheduleManagement/>
          </div>
        );
      case 'back_office_reservation':
        return (
          <div>
            <BackOfficeReservationManagement/>
          </div>
        );
      case 'back_office_wallet':
        return (
          <div>
            <BackOfficeWallet/>
          </div>
        );
      case 'back_office_user_service':
        return (
          <div>
            <BackOfficePersonServiceManagement/>
          </div>
        );
      case 'back_office_agent_service':
        return (
          <div>
            <BackOfficeAgentServiceManagement/>
          </div>
        );
      case 'article_management':
        return (
          <React.Suspense fallback={<div className="p-8 text-center">در حال بارگذاری مدیریت مقالات...</div>}>
            <div>
              <ArticleManagement/>
            </div>
          </React.Suspense>
        );
      case 'seo_management':
        return (
          <React.Suspense fallback={<div className="p-8 text-center">در حال بارگذاری تنظیمات سئو...</div>}>
            <div>
              <SEOManagement/>
            </div>
          </React.Suspense>
        );
      case 'voip_call':
        return (
          <div>
            <VoipCall/>
          </div>
        );
      case 'send_payment_link':
        return (
          <div>
            <SendPaymentLink/>
          </div>
        );
      case 'change_wallet_balance':
        return (
          <div>
            <ChangeWalletBalance/>
          </div>
        );
      case 'send_notification':
        return (
          <div>
            <SendNotification/>
          </div>
        );
      case 'referral_config':
        return (
          <div>
            <ReferralConfigManagement/>
          </div>
        );
      case 'referrals':
        return (
          <div>
            <ReferralManagement/>
          </div>
        );
      case 'referral_profile':
        return (
          <div>
            <ProfileReferral/>
          </div>
        );
      case 'navigate_voip':
        return (
          process.env.REACT_APP_SIMOTEL_PANEL_URL
            ? window.open(process.env.REACT_APP_SIMOTEL_PANEL_URL, "_blank", "noreferrer")
            : <p>پنل مرکز تماس در دسترس نیست.</p>
        );
    }
  };

  if (localStorage.getItem('userInfo')) {
    return <Layout sidebarClickHandler={handleItemClick} userInfo={userInfo}>
      {renderContent()}
    </Layout>
  } else {
    window.location.href = "/login";
  }

};

export default Home;
